module.exports = __webpack_public_path__ + "static/media/Edit.5e63c4ec.svg";